import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LabLocationsResponse, LabLocationsState } from "./index.types";

export const initialLabLocationsState: LabLocationsState = {
  labLocationsData: [],
  labLocationsDataOptions: [],
  labLocationsSuccess: null,
  labLocationsIsLoading: false,
};

const name = "labLocations";

export const labLocationsSlice = createSlice({
  name,
  initialState: initialLabLocationsState,
  reducers: {
    getLabLocations: (state) => {
      state.labLocationsIsLoading = true;
    },
    getLabLocationsSuccess: (state, action: PayloadAction<LabLocationsResponse>) => {
      state.labLocationsSuccess = true;
      state.labLocationsIsLoading = false;
      state.labLocationsData = action.payload.results;
      state.labLocationsDataOptions = action.payload?.results?.map((s) => ({
        label: s?.lab_location_name,
        value: s?.id,
      }));
    },
    getLabLocationsFail: (state) => {
      state.labLocationsSuccess = false;
      state.labLocationsData = [];
      state.labLocationsIsLoading = false;
      state.labLocationsDataOptions = [];
    },
    clearLabLocationsData: (state) => {
      state.labLocationsSuccess = null;
      state.labLocationsData = [];
      state.labLocationsIsLoading = false;
      state.labLocationsDataOptions = [];
    },
  },
});

export const { clearLabLocationsData } = labLocationsSlice.actions;

export default labLocationsSlice.reducer;

export const getLabLocationsList = (id: string | number) => ({
  payload: {
    apiName: name,
    method: "get",
    url: `/api/lablocation/?search=${id}`,
  },
  type: "getLabLocations",
});
